import React from "react";
import { Radio, RadioGroup } from "rsuite";

import { FilterSectionFlexboxGrid, StyledItemFitWidth } from "components/base/FitContainers";

const FiltersPanel = ({
    isMobile,
    loading,
    isGanTrunks,
    isTransitTrunks,
    onChangeGroup,
    filterNode,
    rightNode,
}) => {
    return (
        <FilterSectionFlexboxGrid controlable={!isMobile}>
            <StyledItemFitWidth controlable={!isMobile} isMobile={isMobile}>
                {isGanTrunks ?
                    <RadioGroup
                        inline
                        onChange={onChangeGroup}
                        defaultValue={"numbers"}
                        name="radioList"
                    >
                        <Radio value="numbers" disabled={loading}>Numbers</Radio>
                        <Radio value="groups" disabled={loading}>Groups</Radio>
                    </RadioGroup>
                    : <></>
                }

                {!isTransitTrunks && !isMobile ? filterNode : <></>}

                {!isMobile && !isTransitTrunks
                    ? !isGanTrunks && (
                        <RadioGroup
                            inline
                            onChange={onChangeGroup}
                            defaultValue={"trunk_number"}
                            name="radioList"
                        >
                            <Radio value="trunk_number" disabled={loading}>Numbers</Radio>
                            <Radio value="price_range" disabled={loading}>Ranges</Radio>
                            <Radio value="subdestination" disabled={loading}>Subdestinations</Radio>
                        </RadioGroup>)
                    : filterNode
                }
            </StyledItemFitWidth>

            {rightNode}
        </FilterSectionFlexboxGrid>
    );
};

export default FiltersPanel;
